import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from "@angular/core"
import { Observable, of, EMPTY, from, BehaviorSubject } from "rxjs";
import { catchError, tap, filter, take, switchMap } from "rxjs/operators";
import { Router } from '@angular/router';
import { UserQuery } from './user/user.query';
import { Auth } from 'aws-amplify';
import {GenesystokenService} from './genesystoken.service'
import { requestsService } from './requests/requests.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

    constructor(public user: UserQuery,private apiService: requestsService,private toster:ToastrService,
        private router: Router,public genesysService:GenesystokenService,
        private authService: AuthService) {
        }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        var userToken='';
        if(this.genesysService.tokenType=='genesys'){
            userToken =this.genesysService.dataToken;
        }
        else{
            userToken =this.user.getToken();
        }

        // Pre-request token expiry check (AWS only) — try refresh and retry instead of immediate logout
        if (this.genesysService.tokenType !== 'genesys' && userToken && this.authService.isTokenExpired(userToken)) {
            return this.handleRefreshAndRetry(req, next);
        }

        const modifiedReq = req.clone({
            headers: req.headers.set('Authorization', `${userToken}`).set('region',this.user.getRegion),
        });

        return next.handle(modifiedReq).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                   if(event?.body?.message=='Expired JWT'){
                    if (this.genesysService.tokenType === 'genesys') {
                        this.router.navigate(['/genesys']);
                    } else {
                        // Response already delivered to component; silently refresh token for future requests
                        this.refreshToken();
                    }
                   }
                }
            }),
            catchError((err: any) => {
                this.user.setMessage(err?.error?.message);
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401 || err.status === 403) {
                        if (this.genesysService.tokenType === 'genesys') {
                            this.genesysService.dataToken = null;
                            this.router.navigate(['/genesys']);
                            return of(null as any);
                        } else {
                            // Try refresh and retry the original request instead of immediate logout
                            return this.handleRefreshAndRetry(req, next);
                        }
                    }

                    if (err.status === 500) {
                        Auth.currentAuthenticatedUser().catch(res => {
                            console.log(res);
                            this.user.setToken(null);
                            this.router.navigate(['/genesys']);
                        });
                    }
                    //  if (err.status === 0) {
                    //     this.refreshToken();
                    //     setTimeout(()=>{
                    //         this.MemberShipAPI()
                    //         this.ROleListAPI()
                    //     },1000)
                    // }
                }
                if( err.error=='Environment Already Exist' ||'Environment Already Exist, Please Check Org Name and Id'){
                  throw new Error(err.error);
                }
                else{
  throw new Error(err.status);
                }
            })
        );
    }

    private addAuthHeader(req: HttpRequest<any>, token: string): HttpRequest<any> {
        return req.clone({
            headers: req.headers.set('Authorization', `${token}`).set('region','eu_west_2')
        });
    }

    private handleRefreshAndRetry(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return from(this.refreshToken()).pipe(
                switchMap(newToken => {
                    this.isRefreshing = false;
                    if (newToken) {
                        this.refreshTokenSubject.next(newToken);
                        return next.handle(this.addAuthHeader(req, newToken));
                    }
                    // refreshToken() already showed toast and called logout
                    return EMPTY;
                }),
                catchError(() => {
                    this.isRefreshing = false;
                    return EMPTY;
                })
            );
        } else {
            // Another refresh is already in flight — wait for it to complete, then retry with the new token
            return this.refreshTokenSubject.pipe(
                filter(token => token !== null),
                take(1),
                switchMap(token => next.handle(this.addAuthHeader(req, token!)))
            );
        }
    }

    async refreshToken(): Promise<string | null> {
        try {
            const session = await Auth.currentSession();
            const newToken = session.getIdToken().getJwtToken();

            // Update the token in the user service
            this.user.setToken(newToken);

            return newToken;
        } catch (error) {
            console.error("Error refreshing token:", error);
            this.toster.warning('Session expired. Please login again.');
            this.authService.logout();
            return null;
        }
    }

    
      ROleListAPI(){
        this.apiService.getRoleListByUsername().subscribe(res=>{
          })
      }
}
